import SwapPlanetZap from './SwapPlanetZap'

export default SwapPlanetZap
